/* ==========================================================================
   Mundo Dos Filtros — nossas-lojas.js

   Comportamento da seção "Nossas lojas":
   - mapa com um pin por unidade (Leaflet + OpenStreetMap), ligado à lista;
   - busca por nome, bairro ou cidade (ignorando acentos);
   - botão "Ver a loja mais perto de mim", que usa a geolocalização do
     navegador para reordenar os cards e mostrar a distância em linha reta;
   - botão "Ver todas as lojas", que revela as unidades escondidas.

   A página funciona sem nada disso: todos os cards já vêm no HTML, com
   telefone e rota. O JS só melhora a experiência. O mapa também é opcional —
   se o Leaflet não carregar, a lista continua inteira.
   ========================================================================== */

(function () {
  'use strict';

  var RAIO_TERRA_KM = 6371;

  /* Quanto o pin ocupa abaixo do balão: o balão nasce 34px acima do ponto do
     marcador (popupAnchor), que é a base da gota. */
  var ALTURA_PIN = 34;

  /* Respiro mínimo entre o balão e as bordas do mapa. */
  var FOLGA_POPUP = 12;

  /* Tira acentos e caixa alta para a busca casar "Guara" com "Guará". */
  function normalizar(texto) {
    return (texto || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .trim();
  }

  /* Distância em linha reta entre dois pontos (fórmula de Haversine). */
  function distanciaKm(lat1, lng1, lat2, lng2) {
    var dLat = ((lat2 - lat1) * Math.PI) / 180;
    var dLng = ((lng2 - lng1) * Math.PI) / 180;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    return RAIO_TERRA_KM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function formatarDistancia(km) {
    if (km < 1) return Math.round(km * 1000) + ' m';
    if (km < 10) return km.toFixed(1).replace('.', ',') + ' km';
    return Math.round(km) + ' km';
  }

  function texto(elemento) {
    return elemento ? elemento.textContent.trim() : '';
  }

  function iniciar(secao) {
    var grid = secao.querySelector('[data-lojas-grid]');
    var busca = secao.querySelector('[data-lojas-busca]');
    var btnPerto = secao.querySelector('[data-lojas-perto]');
    var btnMais = secao.querySelector('[data-lojas-mais]');
    var status = secao.querySelector('[data-lojas-status]');
    var caixaMapa = secao.querySelector('[data-lojas-mapa]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-loja]'));
    var limite = parseInt(secao.dataset.limite, 10) || cards.length;
    var expandido = false;
    var ordenadoPorDistancia = false;
    var textoStatusInicial = status ? status.textContent : '';

    var vazio = document.createElement('p');
    vazio.className = 'lojas__vazio';
    vazio.hidden = true;
    grid.appendChild(vazio);

    cards.forEach(function (card) {
      card.dataset.buscaNormalizada = normalizar(card.dataset.busca);
    });

    /* ------------------------------------------------------------- Mapa -- */

    var mapa = null;
    var camadaPins = null;
    var pinVoce = null;
    var cardAtivo = null;

    var logoPin = caixaMapa ? caixaMapa.dataset.pinLogo : '';

    /* Balão em forma de gota (SVG) com a gotinha da marca por cima. O SVG
       usa currentColor, então quem manda na cor é o CSS do .pin-loja. */
    var GOTA_SVG =
      '<svg viewBox="0 0 30 38" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M15 0C7.5 0 2 6 2 13.5c0 9.5 13 24.5 13 24.5s13-15 13-24.5C28 6 22.5 0 15 0z"' +
      ' fill="currentColor" stroke="rgba(4,14,40,.3)" stroke-width="1.5"/></svg>';

    function pinoDaLoja(ativo) {
      return L.divIcon({
        className: '',
        html:
          '<div class="pin-loja' + (ativo ? ' pin-loja--ativo' : '') + '">' +
          GOTA_SVG +
          (logoPin ? '<img src="' + logoPin + '" alt="">' : '') +
          '</div>',
        iconSize: [30, 38],
        iconAnchor: [15, 38],
        popupAnchor: [0, -34]
      });
    }

    /* O popup reaproveita o que já está no card: nada de repetir os dados. */
    function popupDaLoja(card) {
      var ligar = card.querySelector('.loja__ligar');
      var rota = card.querySelector('.loja__rota');
      var horario = texto(card.querySelector('.loja__horario'));
      return (
        '<p class="mapa-popup__nome">' + texto(card.querySelector('.loja__nome')) + '</p>' +
        '<p class="mapa-popup__endereco">' + texto(card.querySelector('.loja__endereco')) + '</p>' +
        (horario ? '<p class="mapa-popup__horario">' + horario + '</p>' : '') +
        '<div class="mapa-popup__acoes">' +
        (ligar
          ? '<a class="botao botao--pequeno" href="' + ligar.getAttribute('href') + '">Ligar ' + texto(ligar) + '</a>'
          : '') +
        (rota
          ? '<a class="botao botao--contorno botao--pequeno" href="' +
            rota.getAttribute('href') +
            '" target="_blank" rel="noopener">Como chegar</a>'
          : '') +
        '</div>'
      );
    }

    function destacar(card) {
      if (cardAtivo && cardAtivo !== card) {
        cardAtivo.classList.remove('loja--ativa');
        if (cardAtivo.marcador) cardAtivo.marcador.setIcon(pinoDaLoja(false));
      }
      cardAtivo = card;
      card.classList.add('loja--ativa');
      if (card.marcador) card.marcador.setIcon(pinoDaLoja(true));
    }

    /* Altura do cabeçalho fixo: tudo que rola precisa descontar isso, senão
       o elemento para debaixo dele. */
    function offsetFixo() {
      return (
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--offset-fixo')
        ) || 0
      );
    }

    /* Rola a página só o necessário para o mapa aparecer inteiro, descontando
       o cabeçalho fixo. Se o mapa já estiver visível, não mexe no scroll. */
    function garantirMapaVisivel() {
      if (!caixaMapa) return;
      var caixa = caixaMapa.getBoundingClientRect();
      var topoFixo = offsetFixo();

      if (caixa.top >= topoFixo && caixa.bottom <= window.innerHeight) return;

      window.scrollTo({
        top: window.pageYOffset + caixa.top - topoFixo - 12,
        behavior: 'smooth'
      });
    }

    /* Espera o quadro seguinte para enquadrar. Duas coisas só ficam prontas
       depois que o navegador desenha: a altura real do balão (que muda com a
       quebra do texto) e o fim de um zoom animado, que faz o Leaflet ignorar
       um setView disparado no meio dele. Sem essa espera o balão abre cortado
       na borda de cima. */
    function acomodarPopup(popup) {
      requestAnimationFrame(function () {
        if (mapa && popup.isOpen()) enquadrarPopup(popup);
      });
    }

    /* Reposiciona o mapa usando a altura real do balão. O balão nasce acima do
       pin, então o pin precisa ficar a essa altura do topo — senão o balão
       estoura a borda e é cortado. Chutar um valor fixo não funciona: a altura
       muda com o tamanho do nome e a largura da tela. */
    function enquadrarPopup(popup) {
      var tamanho = mapa.getSize();

      /* Primeiro a largura: num celular o mapa tem ~265px úteis, e um balão
         mais largo que isso vaza pelas laterais e corta o endereço. */
      var largura = Math.max(180, Math.min(260, tamanho.x - 32));
      if (popup.options.maxWidth !== largura) {
        popup.options.maxWidth = largura;
        popup.update();
      }

      var elemento = popup.getElement();
      if (!elemento) return;

      /* Só depois do update dá para medir a altura, que muda conforme o texto
         quebra na largura nova. */
      var alturaPopup = elemento.offsetHeight;
      var zoom = mapa.getZoom();

      /* O conjunto que precisa aparecer é o balão mais o pin embaixo dele.
         Centralizamos esse bloco inteiro no mapa: sobra a mesma margem em
         cima do balão e embaixo do pin. */
      var alturaBloco = alturaPopup + ALTURA_PIN;
      var alvo = Math.round((tamanho.y + alturaBloco) / 2);

      /* Quando o balão é quase tão alto quanto o mapa, o centro exato jogaria
         o topo dele para fora. Aí manda a folga mínima: balão colado no topo,
         pin o mais baixo que ainda o mantém visível. */
      var alvoMinimo = alturaBloco + FOLGA_POPUP;
      var alvoMaximo = tamanho.y - FOLGA_POPUP;
      alvo = Math.max(Math.min(alvo, alvoMaximo), Math.min(alvoMinimo, alvoMaximo));

      /* Centralizar no eixo X já resolve a horizontal: o balão nasce centrado
         no pin, então pin no meio é balão no meio. */
      var pixelDoPin = mapa.project(popup.getLatLng(), zoom);
      var centro = pixelDoPin.add([0, tamanho.y / 2 - alvo]);
      mapa.setView(mapa.unproject(centro, zoom), zoom, { animate: true });
    }

    /* Leva o mapa até a unidade e abre o popup dela. O enquadramento fino
       fica por conta do 'popupopen', que roda com o balão já medido. */
    /* Roda a ação com o mapa já parado. O evento cobre o caso normal; o prazo
       cobre o caso em que o mapa não chegou a se mexer e o evento nunca vem. */
    function quandoParar(acao) {
      var feito = false;
      function uma() {
        if (feito) return;
        feito = true;
        acao();
      }
      mapa.once('moveend', uma);
      mapa.once('zoomend', uma);
      setTimeout(uma, 400);
    }

    function focarNoMapa(card) {
      if (!mapa || !card.marcador) return;
      destacar(card);

      var zoomAlvo = Math.max(mapa.getZoom(), 14);
      if (zoomAlvo === mapa.getZoom()) {
        card.marcador.openPopup();
        return;
      }

      /* Com zoom animado, abrir o balão na hora faria o enquadramento ser
         calculado sobre um mapa que ainda está se movendo. Espera terminar. */
      mapa.setZoom(zoomAlvo);
      quandoParar(function () {
        card.marcador.openPopup();
      });
    }

    /* Enquadra o mapa nos pins que estão visíveis na lista naquele momento. */
    function enquadrar(extras) {
      if (!mapa) return;
      var pontos = cards
        .filter(function (card) {
          return !card.classList.contains('loja--oculta') && card.marcador;
        })
        .map(function (card) {
          return card.marcador.getLatLng();
        });

      (extras || []).forEach(function (ponto) {
        pontos.push(ponto);
      });

      if (!pontos.length) return;
      mapa.fitBounds(L.latLngBounds(pontos), { padding: [40, 40], maxZoom: 15, animate: true });
    }

    function montarMapa() {
      if (!caixaMapa || typeof L === 'undefined') return;

      mapa = L.map(caixaMapa, { scrollWheelZoom: false, zoomControl: false });
      /* Zoom embaixo à esquerda: os balões abrem na metade de cima do mapa e
         os controles do Leaflet ficam por cima deles se sobrarem no topo. */
      L.control.zoom({ position: 'bottomleft' }).addTo(mapa);
      camadaPins = L.layerGroup().addTo(mapa);

      /* Vale para qualquer balão: aberto pelo card ou clicando direto no pin. */
      mapa.on('popupopen', function (evento) {
        acomodarPopup(evento.popup);
      });

      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 19
      }).addTo(mapa);

      cards.forEach(function (card) {
        var marcador = L.marker([parseFloat(card.dataset.lat), parseFloat(card.dataset.lng)], {
          icon: pinoDaLoja(false),
          title: texto(card.querySelector('.loja__nome')),
          riseOnHover: true
        });
        marcador.bindPopup(popupDaLoja(card), {
          /* minWidth baixo para o balão poder encolher no celular; a largura
             final é ajustada no acomodarPopup, com o mapa já medido. */
          minWidth: 180,
          maxWidth: 260,
          /* O autoPan do Leaflet só empurra o mapa o mínimo para o balão
             caber, o que joga o pin para a borda. Quem enquadra aqui é o
             acomodarPopup, com a conta feita a partir da altura real. */
          autoPan: false
        });
        marcador.on('click', function () {
          destacar(card);
          /* Se a unidade estiver escondida pelo limite da lista, abre a lista
             inteira para o visitante conseguir achá-la embaixo do mapa. */
          if (card.classList.contains('loja--oculta')) {
            expandido = true;
            render();
          }
          /* Nada de rolar a página até o card: o balão do mapa já mostra
             endereço, telefone e rota. Arrastar o visitante para longe do
             mapa só faz ele perder o lugar onde estava. */
        });
        marcador.addTo(camadaPins);
        card.marcador = marcador;

        card.classList.add('loja--clicavel');
        card.addEventListener('click', function (evento) {
          /* Não sequestra o clique nos botões de ligar e de rota. */
          if (evento.target.closest('a')) return;
          garantirMapaVisivel();
          focarNoMapa(card);
        });
      });

      enquadrar();
      /* O container pode ter mudado de tamanho enquanto a página carregava. */
      setTimeout(function () {
        mapa.invalidateSize();
      }, 200);
    }

    /* ------------------------------------------------------- Busca/lista -- */

    /* Aplica busca + limite de exibição de uma vez só, para o DOM ser tocado
       uma única vez por interação. */
    function render() {
      var termo = normalizar(busca ? busca.value : '');
      var visiveis = 0;

      cards.forEach(function (card) {
        var casa = !termo || card.dataset.buscaNormalizada.indexOf(termo) !== -1;
        if (!casa) {
          card.classList.add('loja--oculta');
          if (camadaPins && card.marcador) camadaPins.removeLayer(card.marcador);
          return;
        }
        visiveis++;
        /* Durante a busca mostramos todos os resultados; sem busca, o limite
           vale até o visitante clicar em "Ver todas". */
        var dentroDoLimite = termo || expandido || visiveis <= limite;
        card.classList.toggle('loja--oculta', !dentroDoLimite);
        /* O pin fica no mapa mesmo quando o card está escondido pelo limite:
           o mapa mostra sempre a rede inteira, a lista é que é paginada. */
        if (camadaPins && card.marcador && !camadaPins.hasLayer(card.marcador)) {
          camadaPins.addLayer(card.marcador);
        }
        if (card.classList.contains('loja--oculta')) card.classList.remove('loja--ativa');
      });

      vazio.hidden = visiveis > 0;
      if (visiveis === 0) {
        vazio.textContent = 'Nenhuma unidade encontrada para “' + busca.value.trim() + '”.';
      }

      if (btnMais) {
        btnMais.hidden = Boolean(termo) || expandido || visiveis <= limite;
      }

      if (status) {
        if (termo) {
          status.textContent =
            visiveis === 1 ? '1 unidade encontrada.' : visiveis + ' unidades encontradas.';
        } else if (!ordenadoPorDistancia) {
          status.textContent = textoStatusInicial;
        }
      }
    }

    if (busca) {
      var buscaAnterior = '';
      busca.addEventListener('input', function () {
        render();
        /* Só reenquadra quando o termo muda de verdade, para o mapa não ficar
           pulando a cada tecla repetida. */
        if (busca.value !== buscaAnterior) {
          buscaAnterior = busca.value;
          if (busca.value.trim()) enquadrar();
        }
      });
    }

    if (btnMais) {
      btnMais.addEventListener('click', function () {
        expandido = true;
        render();
      });
    }

    /* ----------------------------------------------------- Geolocalização -- */

    function ordenarPorDistancia(lat, lng, rolar) {
      cards.forEach(function (card) {
        var km = distanciaKm(
          lat,
          lng,
          parseFloat(card.dataset.lat),
          parseFloat(card.dataset.lng)
        );
        card.dataset.km = km;

        var badge = card.querySelector('[data-loja-distancia]');
        if (badge) {
          badge.textContent = formatarDistancia(km);
          badge.hidden = false;
        }
        card.classList.remove('loja--perto');
      });

      cards.sort(function (a, b) {
        return parseFloat(a.dataset.km) - parseFloat(b.dataset.km);
      });
      cards.forEach(function (card) {
        grid.appendChild(card);
      });
      grid.appendChild(vazio);

      var maisPerto = cards[0];
      maisPerto.classList.add('loja--perto');
      ordenadoPorDistancia = true;
      render();

      if (status && !(busca && busca.value.trim())) {
        status.textContent =
          'A unidade mais perto de você é ' +
          texto(maisPerto.querySelector('.loja__nome')) +
          ', a ' +
          formatarDistancia(parseFloat(maisPerto.dataset.km)) +
          ' daqui.';
      }

      if (mapa) {
        if (pinVoce) mapa.removeLayer(pinVoce);
        pinVoce = L.marker([lat, lng], {
          icon: L.divIcon({ className: '', html: '<div class="pin-voce"></div>', iconSize: [18, 18] }),
          title: 'Você está aqui',
          zIndexOffset: 1000
        }).addTo(mapa);
        pinVoce.bindPopup('<p class="mapa-popup__nome">Você está aqui</p>');

        destacar(maisPerto);
        mapa.fitBounds(L.latLngBounds([[lat, lng], maisPerto.marcador.getLatLng()]), {
          padding: [60, 60],
          maxZoom: 15,
          animate: true
        });
        quandoParar(function () {
          maisPerto.marcador.openPopup();
        });
        /* Só arrasta a página quando o visitante pediu. Na permissão dada
           automaticamente na entrada, a lista se reordena onde ele está. */
        if (rolar) garantirMapaVisivel();
      } else if (rolar) {
        maisPerto.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    /* Pede a posição. 'automatico' é a tentativa da entrada na página: ela não
       mostra erro nem mexe no scroll, porque o visitante não pediu nada. */
    function pedirLocalizacao(automatico) {
      if (!('geolocation' in navigator)) return;

      if (btnPerto) btnPerto.setAttribute('aria-busy', 'true');
      if (status && !automatico) {
        status.textContent = 'Procurando a unidade mais perto de você…';
      }

      navigator.geolocation.getCurrentPosition(
        function (pos) {
          if (btnPerto) btnPerto.removeAttribute('aria-busy');
          ordenarPorDistancia(pos.coords.latitude, pos.coords.longitude, !automatico);
        },
        function () {
          if (btnPerto) btnPerto.removeAttribute('aria-busy');
          /* Negou na entrada: silêncio. O botão continua ali para tentar de
             novo quando ele quiser. */
          if (status && !automatico) {
            status.textContent =
              'Não conseguimos acessar sua localização. Use a busca acima para encontrar a unidade mais perto de você.';
          }
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 }
      );
    }

    if (btnPerto) {
      if (!('geolocation' in navigator)) {
        btnPerto.hidden = true;
      } else {
        btnPerto.addEventListener('click', function () {
          pedirLocalizacao(false);
        });
      }
    }

    /* Ao entrar na página, já pede a localização: a promessa da página é
       "sempre tem uma loja perto de você", e ela só se cumpre sozinha se a
       lista já abrir ordenada pela unidade mais próxima. */
    function pedirLocalizacaoNaEntrada() {
      if (secao.dataset.pedirLocalizacao !== 'true') return;
      if (!('geolocation' in navigator)) return;

      /* Se a permissão já está dada, busca direto, sem nenhum aviso na tela.
         Se já foi negada, nem tenta: o navegador só mostraria o erro de novo. */
      if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions
          .query({ name: 'geolocation' })
          .then(function (permissao) {
            if (permissao.state === 'denied') return;
            pedirLocalizacao(true);
          })
          .catch(function () {
            pedirLocalizacao(true);
          });
        return;
      }

      pedirLocalizacao(true);
    }

    montarMapa();
    render();
    pedirLocalizacaoNaEntrada();
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-lojas]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  /* Recarrega quando a seção é reinserida pelo editor de temas da Shopify. */
  document.addEventListener('shopify:section:load', function (evento) {
    var secao = evento.target.querySelector('[data-lojas]');
    if (secao) iniciar(secao);
  });
})();
